<template>
  <div class="sm-select-plan">
    <plan-select
      @submit="onPlanSubmit"
      @plansReceived="showSpinner = false"
    >
      <template slot="header">
        <!-- <template v-if="provider.plan_layout">
          <h1 
            v-if="provider.plan_layout.header"
            class="sm-txt-center"
          >{{provider.plan_layout.header}}</h1>
          <h3 
            v-if="provider.plan_layout.sub_header"
            class="sm-txt-center"
          >{{provider.plan_layout.sub_header}}</h3>
          <p 
            v-if="provider.plan_layout.description"
            class="sm-lead sm-txt-center"
          >{{provider.plan_layout.description}}</p>
        </template> -->
        <template>
          <h2 class="sm-txt-center">Select a plan</h2>
          <!-- <p class="sm-lead sm-txt-center">Cancel anytime</p> -->
        </template>
      </template>
    </plan-select>
    <company-info />
    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import PlanSelect from '@/views/page-elements/PlanSelect';
import CompanyInfo from '@/views/page-elements/CompanyInfo';
import { mapActions, mapGetters } from 'vuex';
import Spinner from "@/components/Spinner";

export default {
  name: 'select-plan',
  components: {
    //'faq-block': FAQ,
    'plan-select': PlanSelect,
    'company-info': CompanyInfo,
    'sm-spinner': Spinner,
  },
  data() {
    return {
      showSpinner: false
    }
  },
  created() {
    this.showSpinner = true;
  },
  computed: {
    ...mapGetters({
      provider: 'provider'
    })
  },
  methods: {
    ...mapActions({
    
    }),
    onPlanSubmit(data) {
      let query = `?plan_id=${data.plan.id}${data.term ? '&term=' + data.term : ''}`;
      this.$router.push(`/sign-up${query}`);
    }
  }
}
</script>

<style lang="scss">
  // @use '@/assets/scss/general/mixins.scss' as *;
  // @use '@/assets/scss/framework/scss-variables.scss' as *;
  // @use '@/assets/scss/page-elements/_plan-select.scss';

  .sm-select-plan {
    position: relative;
  }

  .fade-text-enter,
  .fade-text-leave-to {
    opacity: 0 !important;
    transform: translateY(30px);
  }

  .fade-text-enter-active,
  .fade-text-leave-active {
    transition: transform .2s, opacity .2s;
  }
</style>